import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AccessDenied() {
  const { t } = useTranslation("sessions");

  return (
    <div className="not-found-wrap text-center">
      <h1 className="text-60">{t("errors.accessDeniedTitle")}</h1>
      <p className="text-36 subheading mb-3">{t("errors.title")}</p>
      <p className="mb-5 text-muted text-18">{t("errors.accessDeniedMessage")}</p>

      <Link to="/" className="btn btn-lg btn-primary btn-rounded">
        {t("errors.goHome")}
      </Link>
    </div>
  );
}
